import { getSupabaseIconName, Icon } from "@msuite/ui/icons";
import type { StaticTicket } from "@msuite/utils/types";

/** Props Interface */
interface CommandPlanTicketProps {
	ticket: StaticTicket;
}

export function CommandPlanTicket({ ticket }: CommandPlanTicketProps) {
	return (
		<div
			className="h-stack card bg-primary-50"
			key={ticket.id}
		>
			<Icon
				name={getSupabaseIconName(ticket.type.iconName)}
				size={5}
				color={`var(--color-${ticket.type.color}-500`}
			/>
			<p>{ticket.description}</p>
		</div>
	);
}
